import styled from 'styled-components'
import { BackgroundImage, Flex } from 'pcln-design-system'

export const StyledSponsor = styled(Flex)`
  background-color: rgba(255, 255, 255, 0.77);
`
export const gradientCss = (props) => {
  if (props.imageGradient === 'light') {
    return `position: relative;
          z-index: 1;
          &::before{
          ${props.borderRadius ? `border-radius: ${props.borderRadius};` : ''}
          opacity: 0.5;
          content: "";
          position: absolute;
          display: block;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          z-index: -1;
          background-image: linear-gradient(180deg, rgba(0,24,51,0.2) 0%, rgba(0,24,51,0.1) 100%), linear-gradient(0deg, rgba(0,24,51,0) 0%, rgba(0,24,51,0.5) 100%);
        }`
  } else if (props.imageGradient === 'dark') {
    return `background-image: linear-gradient(180deg, rgba(0,24,51,0.2) 0%, rgba(0,24,51,0.1) 100%), linear-gradient(0deg, rgba(0,24,51,0) 0%, rgba(0,24,51,0.5) 100%), url(${
      props.image
    });
          ${props.borderRadius ? `border-radius: ${props.borderRadius};` : ''}`
  }
}

export const StyledHeroImage = styled(BackgroundImage)`
  ${(props) => gradientCss(props)}
`
